const UserDictionary = {
  addRRoomUser: () => "auth/rrooms-users",
  getRroomsUsers: () => "auth/rrooms-users",
  delRroomsUsers: (id) => `auth/rrooms-users/${id}`,
  delPropertyUsers: (id) => `auth/property-users/${id}`,
  getPropertyUsers: () => "auth/property-users",
  // getPropertyUsersByPrt: (id) => `auth/property-users-by-property/${id}`,
  getPropertyUsersByPrt: () => `auth/property-users`,
  getCustomers: (page, limit, query) => `auth/customers?page=${page}&limit=${limit}${query && '&search='+query}`,

  exportCustomer: (start, end)=> `auth/export-customers?startDate=${start}&endDate=${end}`
};

export default UserDictionary;
